import SubmissionTable from "./SubmissionTable";
import ReportV2 from "Projects/routes/ProjectDetails/routes/ReportV2/ReportV2";

import { isNewDeadlineEnabled } from "Projects/modules/Utils";

import React from "react";

const styles = {
  reportContainerStyle: {
    padding: 0,
  },
};

const SubmissionTableWrapper = props => {
  const {
    template,
    projectGroupId,
    projectDetails,
    disabled,
    renderBottomComp,
  } = props;
  return isNewDeadlineEnabled() ? (
    <ReportV2
      {...props}
      template={template}
      projectGroupId={projectGroupId}
      projectDetails={projectDetails}
      containerStyle={styles.reportContainerStyle}
      showHeaderContainer={false}
      disabled={disabled}
      renderBottomComp={renderBottomComp}
    />
  ) : (
    <SubmissionTable {...props} />
  );
};

export default SubmissionTableWrapper;
